var React = require('react');

function IconIn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M248,8c-136.9,0 -248,111.1 -248,248c0,136.9 111.1,248 248,248c136.9,0 248,-111.1 248,-248c0,-136.9 -111.1,-248 -248,-248Zm-88.322,194.383l-66.306,0l0,213.524l66.306,0l0,-213.524Zm248.233,213.524l0,-117.291c0,-57.397 -12.336,-101.587 -79.442,-101.587c-32.26,0 -53.884,17.705 -62.736,34.481l-0.928,0l0,-29.127l-63.593,0l0,213.524l66.234,0l0,-105.726c0,-27.842 5.283,-54.756 39.757,-54.756c33.974,0 34.473,31.768 34.473,56.54l0,103.942l66.235,0Zm-281.422,-242.65c-21.202,0 -38.4,-17.562 -38.4,-38.764c0,-21.066 17.334,-38.4 38.4,-38.4c21.066,0 38.4,17.334 38.4,38.4c0,21.202 -17.205,38.764 -38.4,38.764Z"}));
}

IconIn.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 496 512","version":"1.1","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = IconIn;

IconIn.default = IconIn;
